module.exports = __webpack_public_path__ + "static/img/12.40aac95.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/5/eng/12.png
// module id = ZZWy
// module chunks = 0